"use client"

import { ListTree } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListTreeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListTreeIcon = component(Icon)({ as: ListTree })
